import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import TableHeader from "../../Datatable/Header/Index";
import PaginationComponent from "../../Datatable/Pagination/Index";
import Search from "../../Datatable/Search/Index";
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";

const ListSubAdmin = () => {
    document.title = "DirtMap - Sub Admin Index";
    const [loader, showLoader, hideLoader] = UseFullPageLoader();

    const [loading, setLoading] = useState(true);
    const [userList, setUserList] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [sorting, setSorting] = useState({ field: "", order: "" });

    const ITEMS_PER_PAGE = 10;

    const headers = [
        { name: "No#", field: "id", sortable: false },
        { name: "Name", field: "first_name", sortable: true },
        { name: "Email", field: "email", sortable: true },
        { name: "Company Name", field: "company_name", sortable: true },
        { name: "Created At", field: "created_at", sortable: true },
        { name: "Phone Number", field: "phone_number", sortable: true },
        { name: "Status", field: "status", sortable: false },
        { name: "Action", field: "action", sortable: false }
    ];

    const getData = () => {
        axios.get(`/api/sub/admin/list`).then(res => {
            if (res.data.result) {
                setUserList(res.data.result);
            }
            setLoading(false);
        });
    }

    useEffect(() => {
        showLoader();
        getData();
        hideLoader();
    }, []);

    const userData = useMemo(() => {
        let computedUserList = userList;
       // return computedUserList;
        if(search){
            computedUserList = computedUserList.filter(
                userList => 
                userList.first_name.toLowerCase().includes( search.toLowerCase()) || 
                userList.last_name.toLowerCase().includes( search.toLowerCase()) ||
                userList.email.toLowerCase().includes( search.toLowerCase()) ||
                userList.company_name.toLowerCase().includes( search.toLowerCase()) || 
                userList.created_at.toLowerCase().includes( search.toLowerCase()) || 
                userList.phone_number.toLowerCase().includes( search.toLowerCase())
            );
        }

        setTotalItems(computedUserList.length);

        //sorting comment
        if(sorting.field) {
            const reversed = sorting.order === "asc" ? 1 : -1;
            computedUserList = computedUserList.sort(
                (a,b) => reversed * a[sorting.field].localeCompare(b[sorting.field])

            );
        }
        return computedUserList.slice(

            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE

            );
     }, [userList, currentPage, search, sorting]);

    const deleteUser = (e, id) => {
        e.preventDefault();
        const thisclicked = e.currentTarget;
        //thisclicked.innerHtml = 'Deleting';
        axios.delete(`/api/user/delete/${id}`).then(res => {
            if (res.data.status_code === 200) {
                swal('success', res.data.message, 'success');
                getData();
                //thisclicked.closest('tr').remove();
            } else if (res.data.status_code === 404) {
                swal('error', 'No User Id Found', 'error');
                //thisclicked.innerHtml = 'Delete';
            }
        });

    }


    const updateStatus = (e, id, status) => {
        e.preventDefault();
        const thisclicked = e.currentTarget;
        let statusMsg = status === '1' ? 'Inactive' : 'Active';
        thisclicked.innerText =  statusMsg;
        axios.post(`/api/update/status/user/${id}/${status}`).then(res => {
            if (res.data.status_code === 200) {
                swal('success', res.data.message, 'success');
                getData();
            } else if (res.data.status_code === 404) {
                swal('error', 'No Post Site Id Found', 'error');
                //thisclicked.innerHtml = 'Delete';
            }
        });
    }

    var viewuser_HTMLTABLE = "";
    if (loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;

    } else {
        viewuser_HTMLTABLE =
        userData.map((item,index) => {
            const created_at = new Date(item.created_at);

            return (<tr key={item.id}>
                <td>{ index + 1 }</td>
                <td>{item.first_name} {item.last_name}</td>
                <td>{item.email}</td>
                <td>{item.phone_number}</td>
                <td>{item.company_name}</td>
                <td>{created_at.toISOString().split('T')[0]}</td>
                <td>

                    <button type="button" style={{width: "62px"}} onClick={(e) => updateStatus(e, item.id, item.status)} className="btn btn-primary btn-circle btn-sm">
                    {item.status === '1' ? 'Active' : 'Inactive'}
                        </button>
                    </td>  
                <td className="list-action-sec">
                    <Link to={`/admin/sub-admin/view/${item.id}`} className="btn btn-info btn-circle btn-sm mr-2" title="View user details">
                        <i className="fa fa-eye"></i>
                    </Link>
                    <Link to={`/admin/sub-admin/edit/${item.id}`} className="btn btn-warning btn-circle btn-sm mr-2">
                        <i className="fas fa-edit"></i>
                    </Link>
                    <button type="submit" onClick={(e) => deleteUser(e, item.id)} className="btn btn-danger btn-circle btn-sm">
                        <i className="fas fa-trash"></i>
                    </button>
                </td>
            </tr>)
        });
    }


    return (
        <div className="container-fluid">
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <div className="row align-items-center">
                        <div className="col-sm-5">
                            <h4 className="card-title mb-0">Sub Admin List</h4>
                        </div>
                        <div className="col-sm-7">
                            <div className="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                                <Link to="/admin/sub-admin/add" className="btn btn-success ml-1" data-toggle="tooltip" title="Create New" data-original-title="Create New"><i className="fa fa-plus-circle"></i> Add More</Link>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="col-sm-12 mt-3">
                        <Search 
                         onSearch = {(value) => {
                            setSearch(value);
                            setCurrentPage(1);
                         }}   
                        />
                    </div>
                <div className="card-body">
                   
                    <div className="table-responsive">

                        <table className="table table-bordered" id="dataTable" width="100%">
                            <TableHeader headers={headers}
                                onSorting={(field, order) =>
                                setSorting({ field, order })}
                            />
                            <tbody>

                                {viewuser_HTMLTABLE}

                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-9">
                            {/* <div className="dataTables_info" id="dataTable_info" role="status" aria-live="polite">Showing 1 to 1 of 1 entries</div> */}
                        </div>
                        <div className="col-sm-12 col-md-3">
                            <PaginationComponent
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListSubAdmin;